/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DetalleEncuestaModelDto } from '../models/detalle-encuesta-model-dto';
import { encuestasControllerDetalleEncuestaPaciente } from '../fn/paciente-encuestas/encuestas-controller-detalle-encuesta-paciente';
import { EncuestasControllerDetalleEncuestaPaciente$Params } from '../fn/paciente-encuestas/encuestas-controller-detalle-encuesta-paciente';
import { encuestasControllerEnviarEncuestaPaciente } from '../fn/paciente-encuestas/encuestas-controller-enviar-encuesta-paciente';
import { EncuestasControllerEnviarEncuestaPaciente$Params } from '../fn/paciente-encuestas/encuestas-controller-enviar-encuesta-paciente';
import { encuestasControllerGetDetalleEncuestaPaciente } from '../fn/paciente-encuestas/encuestas-controller-get-detalle-encuesta-paciente';
import { EncuestasControllerGetDetalleEncuestaPaciente$Params } from '../fn/paciente-encuestas/encuestas-controller-get-detalle-encuesta-paciente';
import { encuestasControllerGetEncuestasPaciente } from '../fn/paciente-encuestas/encuestas-controller-get-encuestas-paciente';
import { EncuestasControllerGetEncuestasPaciente$Params } from '../fn/paciente-encuestas/encuestas-controller-get-encuestas-paciente';
import { EncuestasPacPacienteModelDto } from '../models/encuestas-pac-paciente-model-dto';
import { EncuestasPacPacientePreguntasModelDto } from '../models/encuestas-pac-paciente-preguntas-model-dto';

@Injectable({ providedIn: 'root' })
export class PacienteEncuestasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `encuestasControllerGetEncuestasPaciente()` */
  static readonly EncuestasControllerGetEncuestasPacientePath = '/api/paciente-encuestas/encuestas-paciente';

  /**
   * Encuestas del Paciente.
   *
   * Obtiene las encuestas asociadas al paciente.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encuestasControllerGetEncuestasPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  encuestasControllerGetEncuestasPaciente$Response(params?: EncuestasControllerGetEncuestasPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EncuestasPacPacienteModelDto>>> {
    return encuestasControllerGetEncuestasPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Encuestas del Paciente.
   *
   * Obtiene las encuestas asociadas al paciente.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encuestasControllerGetEncuestasPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encuestasControllerGetEncuestasPaciente(params?: EncuestasControllerGetEncuestasPaciente$Params, context?: HttpContext): Observable<Array<EncuestasPacPacienteModelDto>> {
    return this.encuestasControllerGetEncuestasPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EncuestasPacPacienteModelDto>>): Array<EncuestasPacPacienteModelDto> => r.body)
    );
  }

  /** Path part for operation `encuestasControllerGetDetalleEncuestaPaciente()` */
  static readonly EncuestasControllerGetDetalleEncuestaPacientePath = '/api/paciente-encuestas/detalle-encuesta-paciente/{uuidEncuesta}';

  /**
   * Respuestas de paciente a una encuesta.
   *
   * Obtiene las respuestas de una encuesta asociada al paciente respondida
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encuestasControllerGetDetalleEncuestaPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  encuestasControllerGetDetalleEncuestaPaciente$Response(params: EncuestasControllerGetDetalleEncuestaPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DetalleEncuestaModelDto>>> {
    return encuestasControllerGetDetalleEncuestaPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Respuestas de paciente a una encuesta.
   *
   * Obtiene las respuestas de una encuesta asociada al paciente respondida
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encuestasControllerGetDetalleEncuestaPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encuestasControllerGetDetalleEncuestaPaciente(params: EncuestasControllerGetDetalleEncuestaPaciente$Params, context?: HttpContext): Observable<Array<DetalleEncuestaModelDto>> {
    return this.encuestasControllerGetDetalleEncuestaPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DetalleEncuestaModelDto>>): Array<DetalleEncuestaModelDto> => r.body)
    );
  }

  /** Path part for operation `encuestasControllerDetalleEncuestaPaciente()` */
  static readonly EncuestasControllerDetalleEncuestaPacientePath = '/api/paciente-encuestas/encuestas-paciente/{uuidEncuesta}';

  /**
   * Detalles de la encuesta del Paciente.
   *
   * Obtiene los detalles de una encuesta asociada al paciente.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encuestasControllerDetalleEncuestaPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  encuestasControllerDetalleEncuestaPaciente$Response(params: EncuestasControllerDetalleEncuestaPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<EncuestasPacPacientePreguntasModelDto>> {
    return encuestasControllerDetalleEncuestaPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Detalles de la encuesta del Paciente.
   *
   * Obtiene los detalles de una encuesta asociada al paciente.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encuestasControllerDetalleEncuestaPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  encuestasControllerDetalleEncuestaPaciente(params: EncuestasControllerDetalleEncuestaPaciente$Params, context?: HttpContext): Observable<EncuestasPacPacientePreguntasModelDto> {
    return this.encuestasControllerDetalleEncuestaPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<EncuestasPacPacientePreguntasModelDto>): EncuestasPacPacientePreguntasModelDto => r.body)
    );
  }

  /** Path part for operation `encuestasControllerEnviarEncuestaPaciente()` */
  static readonly EncuestasControllerEnviarEncuestaPacientePath = '/api/paciente-encuestas/enviar-encuesta-paciente/{uuidEncuesta}';

  /**
   * Enviar Encuesta del Paciente.
   *
   * Envía una encuesta asociada al paciente.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `encuestasControllerEnviarEncuestaPaciente()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  encuestasControllerEnviarEncuestaPaciente$Response(params: EncuestasControllerEnviarEncuestaPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return encuestasControllerEnviarEncuestaPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Enviar Encuesta del Paciente.
   *
   * Envía una encuesta asociada al paciente.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `encuestasControllerEnviarEncuestaPaciente$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  encuestasControllerEnviarEncuestaPaciente(params: EncuestasControllerEnviarEncuestaPaciente$Params, context?: HttpContext): Observable<void> {
    return this.encuestasControllerEnviarEncuestaPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
